import { useTheme } from '@evi/skins';
import { DefaultNetworkRing } from '../themes/default/DefaultNetworkRing.js';
import { LuceNetworkGauge } from '../themes/luce/LuceNetworkGauge.js';

export interface NetworkGaugeProps {
  online: number;
  total: number;
  faulted?: number;
  size?: number;
}

/**
 * Theme-aware "% chargers online" visual.
 *   Default → clean green ring with percentage in the middle.
 *   Luce    → half-circle sector dial — tri-zone warning arc, tick
 *             ring, sweeping needle, digital `online / total` readout.
 *             Pulses a pill below the dial when `faulted > 0`.
 */
export function NetworkGauge({ online, total, faulted = 0, size = 220 }: NetworkGaugeProps) {
  const { theme } = useTheme();
  if (theme.id === 'luce') {
    return <LuceNetworkGauge online={online} total={total} faulted={faulted} size={size} />;
  }
  return <DefaultNetworkRing online={online} total={total} faulted={faulted} size={size} />;
}
